import { render, staticRenderFns } from "./SidebarArchive.vue?vue&type=template&id=2777af86"
import script from "./SidebarArchive.vue?vue&type=script&lang=js"
export * from "./SidebarArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports